import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-781f3f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "role"]
const _hoisted_2 = {
  key: 0,
  class: "rl-badge__dot",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  class: "rl-badge__avatar",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle" }, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "rl-badge__country",
  "aria-hidden": "true"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1))
const _hoisted_7 = {
  key: 3,
  class: "rl-badge__icon rl-badge__icon--leading",
  "aria-hidden": "true"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" }, null, -1))
const _hoisted_9 = {
  key: 4,
  class: "rl-badge__label"
}
const _hoisted_10 = {
  key: 5,
  class: "rl-badge__icon rl-badge__icon--trailing",
  "aria-hidden": "true"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" }, null, -1))
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_14 = {
  key: 7,
  class: "rl-badge__only",
  "aria-hidden": "true"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" }, null, -1))

import { computed } from 'vue';

type BadgeSize = 'sm' | 'md' | 'lg';
type BadgeState = 'default' | 'hover';
type BadgeVariant = 'pill' | 'badge' | 'badge-modern';
type BadgeTone = 'color' | 'outline';
type BadgeColor = 
  | 'gray' 
  | 'brand' 
  | 'error' 
  | 'warning' 
  | 'success' 
  | 'gray-blue' 
  | 'blue-light' 
  | 'indigo' 
  | 'purple' 
  | 'blue' 
  | 'pink' 
  | 'orange';
type BadgeIcon = 
  | 'none' 
  | 'dot' 
  | 'x-close' 
  | 'icon-leading' 
  | 'icon-trailing' 
  | 'only' 
  | 'avatar' 
  | 'country';

interface Props {
  label?: string;
  size?: BadgeSize;
  state?: BadgeState;
  variant?: BadgeVariant;
  tone?: BadgeTone;
  color?: BadgeColor;
  icon?: BadgeIcon;
  ariaLabel?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LingoBadgeComponent',
  props: {
    label: { default: 'Badge' },
    size: { default: 'sm' },
    state: { default: 'default' },
    variant: { default: 'pill' },
    tone: { default: 'color' },
    color: { default: 'gray' },
    icon: { default: 'none' },
    ariaLabel: { default: '' }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;





const variantClass = computed(() => props.variant);
const toneClass = computed(() => props.variant === 'badge-modern' ? 'modern' : props.tone);
const colorClass = computed(() => props.color);

const hasLeadingIcon = computed(() => props.icon === 'icon-leading');
const hasTrailingIcon = computed(() => props.icon === 'icon-trailing');
const hasAvatar = computed(() => props.icon === 'avatar');
const hasCountry = computed(() => props.icon === 'country');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["rl-badge", [
      `rl-badge--${variantClass.value}`,
      `rl-badge--${toneClass.value}`,
      `rl-badge--${colorClass.value}`,
      `rl-badge--${_ctx.size}`,
      { 'is-only': _ctx.icon === 'only', 'is-hover': _ctx.state === 'hover' }
    ]]),
    "aria-label": _ctx.icon === 'only' ? _ctx.ariaLabel : undefined,
    role: _ctx.icon === 'only' ? 'img' : undefined
  }, [
    (_ctx.icon === 'dot')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (hasAvatar.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "avatar", {}, () => [
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    (hasCountry.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _renderSlot(_ctx.$slots, "country", {}, () => [
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    (hasLeadingIcon.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
          _renderSlot(_ctx.$slots, "leading-icon", {}, () => [
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.icon !== 'only')
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (hasTrailingIcon.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
          _renderSlot(_ctx.$slots, "trailing-icon", {}, () => [
            _hoisted_11
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.icon === 'x-close')
      ? (_openBlock(), _createElementBlock("button", {
          key: 6,
          type: "button",
          class: "rl-badge__close",
          "aria-label": `Remove ${_ctx.label}`,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, [
          _renderSlot(_ctx.$slots, "close-icon", {}, () => [
            _hoisted_13
          ])
        ], 8, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.icon === 'only')
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
          _renderSlot(_ctx.$slots, "only-icon", {}, () => [
            _hoisted_15
          ])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})